<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img
          :src="require('../assets/greennote.png')"
          class="my-3"
          contain
          height="200"
        />
      </v-col>

      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          コースID: {{ this.$route.params.client }}-{{ this.$route.params.id }}
        </h1>
        <h2 class="display-1 font-weight-bold mb-3"></h2>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: "Cource",

  data: () => ({
    //
  }),

  mounted: function () {
    this.transferToCourse();
  },

  methods: {
    transferToCourse() {
      const client = this.$route.params.client;
      const id = this.$route.params.id;
      const href = `/courses/${client}/${id}`;
      console.log(href);

      const route = {
        path: href,
        name: `route-${client}-${id}`,
        component: () =>
          import(
            /* webpackChunkName: "views_" */ `../components/courses/${client}/${id}.vue`
          ),
        // meta: { requireAuth: true },
      };

      this.$router.addRoute(route);
      this.$router.push(href);
    },
  },
};
</script>
<style>
.signin {
  margin: 20px;
}
input {
  font-size: 16px !important;
}
@media screen and (max-width: 480px) {
  .signin div {
    min-width: 0;
  }
}
</style>
